import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material/";
import actions from "../../Store/actions";
import Routes from "./Routes";
import styles from "./styles";
import { helpers } from "../../common/lib";
import { strings } from "../../common/i18n";
import { logToSentry } from "../../config/Sentry";
import Loading from "../../common/components/Loading";

/**
 * Audit Review Component
 */

export default () => {
    const { audits } = useSelector((state) => state);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const params = useParams();
    const { auditId } = params;

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                if (auditId) {
                    await Promise.all([
                        dispatch(actions.accounts.create.getRequest()),
                        dispatch(actions.altAssets.create.getRequest(auditId)),
                        dispatch(
                            actions.assignmentDetails.create.getRequest(auditId)
                        ),
                        dispatch(
                            actions.auditReview.create.getRequest(auditId)
                        ),
                        dispatch(
                            actions.assetFoundElsewhere.create.getRequest(
                                auditId
                            )
                        ),
                        dispatch(
                            actions.auditReview.create.statusSet(["expected"])
                        )
                    ]);

                    setLoading(false);
                }
            } catch (error) {
                const errStr = error.toString();
                console.error(errStr);
                logToSentry("On loading audit:", { error });
                dispatch(
                    actions.toast.create.error(strings("errors.onLoadAudit"))
                );
            }
        };
        dispatch(actions.auditReview.create.init());
        fetchData();
    }, [auditId]);

    return loading ? <Loading loadingText="loadingAudit" /> : <Routes />;
};
